import { dsLogger } from '../../shared/services/logger/logger.instance';

export const templateEditorLogger = dsLogger.extend('template-editor');
